export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela/es/minifyCSSString.js
// module id = 732
// module chunks = 0